// extracted by mini-css-extract-plugin
module.exports = {"section":"K3_section__buvNG"};